module.exports = __webpack_public_path__ + "img/strategy_ub_grey.25ce382c.svg";